import React, {Component} from "react";

class RegisterSuccess extends Component {

    render(){
        const { os } = this.props;

        return <section id="lastStep">
            <div>
                <div className="header-image">
                </div>
                <div className="icon">
                    <img src="assets/images/icon_download.svg" />
                </div>
                <div>
                    <div className="wrap-content-email">
                        <h2 className="blue">
                            cadastro finalizado!
                        </h2>
                        {this.props.isCpfRegister ?
                            <p>
                            Para finalizar, acesse o app.
                            </p> :
                            <p>
                                Para finalizar, acesse o app e participe da escala.<br/>
                                <strong>{this.props.departmentName}</strong>
                            </p>
                        }
                    </div>
                    {
                        os.includes("OS") &&
                        <div className="download">
                            <p className="download">
                            Baixe para Iphone
                            </p>
                            <a href="https://itunes.apple.com/br/app/escala/id998551095?mt=8"><img src="assets/images/badge_appstore.svg"/></a>
                        </div>
                        }
                        {
                        os.includes("Android") &&
                        <div className="download">
                            <p>
                            Baixe para o Android
                            </p>
                            <a href="https://play.google.com/store/apps/details?id=br.einstein.escala&hl=pt_BR"><img src="assets/images/badge_googleplay.svg"/></a>
                        </div>
                        }
                        {
                        !os.includes("Android") && !os.includes("OS") &&
                        <div className="download">
                            <p>
                                Faça o Download
                            </p>
                            <a href="https://play.google.com/store/apps/details?id=br.einstein.escala&hl=pt_BR"><img src="assets/images/badge_googleplay.svg"/></a>
                            <a href="https://itunes.apple.com/br/app/escala/id998551095?mt=8"><img src="assets/images/badge_appstore.svg"/></a>
                        </div>
                        }
                </div>
            </div>
        </section>
    }
} export default RegisterSuccess;


// WEBPACK FOOTER //
// ./src/app/home/container/registerSuccess.js